import { useTranslation } from "react-i18next";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

export function RestrictionsSection({ consulta, editing, form, onFieldChange }) {
  const { t } = useTranslation();

  return (
    <div className="bg-white border border-slate-200 rounded-lg p-6">
      <h2 className="text-lg font-heading font-semibold text-slate-900 mb-4">{t('consultaDetail.votingRestrictions')}</h2>

      {editing ? (
        <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <div className="mb-4">
            <Label className="text-sm font-medium text-blue-800 mb-2 block">{t('consultaDetail.restrictionType')}</Label>
            <div className="grid grid-cols-2 gap-3">
              <button type="button" onClick={() => onFieldChange('restrictionType', 'options')} data-testid="edit-restriction-type-options"
                className={`p-3 rounded-lg border-2 text-left transition-all ${form.restrictionType === 'options' ? 'border-blue-500 bg-blue-100' : 'border-slate-200 bg-white hover:border-blue-300'}`}>
                <p className="font-medium text-slate-900">{t('consultaDetail.byOptionCount')}</p>
                <p className="text-xs text-slate-500 mt-1">{t('consultaDetail.byOptionCountDesc')}</p>
              </button>
              <button type="button" onClick={() => onFieldChange('restrictionType', 'amount')} data-testid="edit-restriction-type-amount"
                className={`p-3 rounded-lg border-2 text-left transition-all ${form.restrictionType === 'amount' ? 'border-blue-500 bg-blue-100' : 'border-slate-200 bg-white hover:border-blue-300'}`}>
                <p className="font-medium text-slate-900">{t('consultaDetail.byMaxAmount')}</p>
                <p className="text-xs text-slate-500 mt-1">{t('consultaDetail.byMaxAmountDesc')}</p>
              </button>
            </div>
          </div>
          {form.restrictionType === 'options' && (
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className="text-sm text-blue-800 mb-1 block">{t('consultaDetail.minOptions')}</Label>
                <Input type="number" min="1" value={form.minOptions} onChange={(e) => onFieldChange('minOptions', e.target.value)} className="h-10" data-testid="edit-min-options-input" />
              </div>
              <div>
                <Label className="text-sm text-blue-800 mb-1 block">{t('consultaDetail.maxOptions')}</Label>
                <Input type="number" min="1" value={form.maxOptions} onChange={(e) => onFieldChange('maxOptions', e.target.value)} className="h-10" data-testid="edit-max-options-input" />
              </div>
            </div>
          )}
          {form.restrictionType === 'amount' && (
            <div>
              <Label className="text-sm text-blue-800 mb-1 block">{t('consultaDetail.maxTotalAmount')}</Label>
              <Input type="number" min="0" value={form.maxTotalAmount} onChange={(e) => onFieldChange('maxTotalAmount', e.target.value)}
                placeholder="Ex: 50000" className="h-10 w-48" data-testid="edit-max-total-amount-input" />
              <p className="text-xs text-blue-600 mt-1">{t('consultaDetail.amountHint')}</p>
            </div>
          )}
        </div>
      ) : (
        <div className="space-y-3">
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-slate-500">{t('consultaDetail.type')}:</span>
            <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-sm font-medium">
              {consulta.restriction_type === 'amount' ? t('consultaDetail.byMaxAmountType') : t('consultaDetail.byOptionCountType')}
            </span>
          </div>
          {consulta.restriction_type === 'options' ? (
            <div className="flex gap-4">
              <div><span className="text-sm text-slate-500">{t('consultaDetail.min')}: </span><span className="font-medium">{consulta.min_options || 1} {(consulta.min_options || 1) === 1 ? t('consultaDetail.option') : t('consultaDetail.options')}</span></div>
              <div><span className="text-sm text-slate-500">{t('consultaDetail.max')}: </span><span className="font-medium">{consulta.max_options || 1} {(consulta.max_options || 1) === 1 ? t('consultaDetail.option') : t('consultaDetail.options')}</span></div>
            </div>
          ) : (
            <div>
              <span className="text-sm text-slate-500">{t('consultaDetail.maxAmount')}: </span>
              <span className="font-medium text-emerald-600">
                {consulta.max_total_amount ? consulta.max_total_amount.toLocaleString('ca-ES', { style: 'currency', currency: 'EUR' }) : t('consultaDetail.notDefined')}
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
